'use client';

import { useState } from 'react';


interface ComparisonMatrixProps {
  services: Array<{
    id: string;
    title: string;
    features: {
      duration: string;
      frequency: string;
      difficulty: string;
      season: string;
    };
  }>;
}

export default function ComparisonMatrix({ services }: ComparisonMatrixProps) {
  const [selectedService, setSelectedService] = useState<string | null>(null);

  const features = [
    { key: 'duration', label: 'Typical Duration', icon: 'ClockIcon' },
    { key: 'frequency', label: 'Recommended Frequency', icon: 'CalendarIcon' },
    { key: 'difficulty', label: 'Complexity Level', icon: 'ChartBarIcon' },
    { key: 'season', label: 'Best Season', icon: 'SunIcon' },
  ];

  return null;
}